import React from 'react'
import { SvgIconProps } from '@mui/material/SvgIcon'
import Schedule from '@mui/icons-material/Schedule'

const ClockIcon: React.FC<SvgIconProps> = props => {
  return <Schedule {...props} />
}

export default ClockIcon
